import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsFormsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-settings-forms',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms',
};
